import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  restrictedFormIconTooltip: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header-new.form-card-icon.restricted-form-icon-tooltip',
    defaultMessage: 'Only specific people can view this form',
    description: 'Tooltip for the restricted form icon used in the form card header.'
  }
});